import React from "react";
import PropTypes from "prop-types";

const Comments = ({ comments = "", editable, commentsUpdated }) => {
  const MAX_CHAR_LIMIT = 250;

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length > MAX_CHAR_LIMIT) {
      return;
    }

    commentsUpdated(value);
  };

  return (
    <div className="fele-cart-comments">
      <div className="fele-content">
        <div className="input-wrapper">
          {/* Character count */}
          <div className="max-char-limit">
            {comments.length}/{MAX_CHAR_LIMIT}
          </div>

          {/* Textarea for comments */}
          <textarea
            value={comments}
            onChange={handleChange}
            onBlur={handleChange}
            readOnly={editable}
            maxLength={MAX_CHAR_LIMIT}
            style={{ height: "300px", width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

Comments.propTypes = {
  commentsUpdated: PropTypes.func,
  comments: PropTypes.string,
  editable: PropTypes.bool,
};

export default Comments;
